/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.15",
    versionName: "0.2.0-nightly.2025.10.15",
    versionChannel: "nightly",
    buildDate: "2025-10-15T00:09:11.786Z",
    commitHash: "233a781608541521ff87de9afea520a5f20b353f",
};
